module.exports = __webpack_public_path__ + "img/home-business-icon.00fad970.svg";